import { Modal } from "react-bootstrap";
import { RootState, useAppDispatch } from "../../../redux/store";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { obtenerClientesPorQuery } from "../../../redux/actions/actionsConsulta";
import Loading from "../../helpers/Loading/Loading";
import { HayDobleTap } from "../../../Utils/funciones";


interface ChildProps{
    query: string
    mostrar: boolean
    setMostrar:(value:boolean)=> void
    setCliente:(param:string)=> void
    campoBusqueda: "id"|"cedula"
}
/**
 * 
 * @param query Activa la búsqueda inicial de los clientes 
 * @param mostrar El valor de la visibilidad de esta pantalla
 * @param setMostrar Modifica la visibilidad de la pantalla
 * @param setCliente Función externa que activaremos cuando se seleccione un cliente, esta función debe recibir como parametro un idCliente
 */
const BusquedaCliente: React.FC<ChildProps> = ({query, mostrar, setMostrar, setCliente, campoBusqueda}) =>{const dispatch = useAppDispatch()

    //clientes que se obtuvieron en la búsqueda inicial dentro de la base de datos
    const ClientesRecuperados = useSelector((state:RootState) => state.consulta.BusquedaCliente)
    
    //Input que solo filtrará los datos obtenidos de la DB
    const [filtroLocal, setFiltroLocal] = useState("")

    const tBusqueda = useRef<HTMLInputElement>(null)
  
    //Activamos la búsqueda local, se ejecutará cada vez que se muestre esta pantalla
    useEffect(() => {
      if(mostrar){
        BuscarEnDB(query)
        setFiltroLocal(query)
        tBusqueda.current?.focus()
      }
    },[mostrar === true])

    //función que vuelve a buscar los datos en la BD
    function BuscarEnDB(query:string){
        dispatch(obtenerClientesPorQuery(query))
    }

    //Ejectuta la función externa alimentadola del idCliente seleccionado, y deja de mostrar esta pantalla
    function DevolverCliente(idCliente:number){
        const cliente = ClientesRecuperados.info.find(el => el.id === idCliente)
        if(cliente){
            switch(campoBusqueda){
                case "cedula":
                    setCliente(cliente.cedula)
                    break;
                case "id":
                    setCliente(cliente.id.toString())
                    break;
            }
            setMostrar(false)
        }
    }    

    function cerrarPantalla(){
      //Para evitar que se abra y cierre la pantalla en los usuarios de móvil
      if(!HayDobleTap()){
        setMostrar(false)
      }
    }

    return (
        <>
          <Modal show={mostrar} 
            onHide={() =>cerrarPantalla()}
            centered 
            animation={false}
           >
            <Modal.Header>
              <Modal.Title className="d-flex w-100">
                <div className="d-flex w-100">
                    <input 
                        type="text"
                        style={{fontSize:"1rem", width:"100%", padding:"0 10px", borderRadius:"5px"}} 
                        value={filtroLocal} 
                        onChange={(e) => setFiltroLocal(e.target.value)} 
                        onKeyDown={(e) => e.key === "Enter"? BuscarEnDB(filtroLocal): null }
                        ref={tBusqueda}
                        placeholder="Ingrese una parte de la cédula o Razón Social"
                    />
                    <button className="btn btn-primary ml-2" onClick={() => BuscarEnDB(filtroLocal)}>Buscar</button>
                </div>
              </Modal.Title>
            </Modal.Header>
            
            <Modal.Body >
              {ClientesRecuperados.loading === false?
              ClientesRecuperados.info.length>0?
                <>
                  <table style={{overflowY: "scroll", maxHeight:"70vh"}} className="table mb-4 contextual-table table-responsive">
                    <thead>
                      <tr className="table-primary">
                        <th>Razon Social</th>
                        <th>Nombre comercial</th>
                        <th>Cédula</th>
                        <th>Dirección</th>
                        <th>telefono</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ClientesRecuperados.info.map((cl, i) =>
                        <tr 
                          key={i} 
                          onDoubleClick={() => DevolverCliente(cl.id)} //PC
                          onTouchStart={() => HayDobleTap()? DevolverCliente(cl.id): null} //Móvil
                          >
                            <td style={{width:"25%"}}>{cl.razonSocial}</td>
                            <td style={{width:"25%"}}>{cl.nombreComercial}</td>
                            <td style={{width:"10%"}}>{cl.cedula}</td>
                            <td style={{width:"30%"}}>{cl.direccion}</td>
                            <td style={{width:"10%"}}>{cl.telefono}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
                :<div className='mt-3 mb-3 text-center'>
                  <h5 className='text-danger'>No se encontraron registros</h5>
                </div>
              : 
              <Loading/>
              }
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex justify-content-between w-100">
                <span >Para seleccionar un registro toque dos veces la pantalla</span>
                <button className='btn btn-primary' onClick={() => cerrarPantalla()}>Cerrar</button>
              </div>
            </Modal.Footer>
          </Modal>
        </>
      );
}

export default BusquedaCliente 